// Run-state badges (RESTYLE §2, §5).
//   <LiveBadge size? label? ping? title? className?>{extra?}</LiveBadge>
//       filled live-cyan "LIVE" with a radar-ping dot (static under reduced motion); `extra` follows a hairline divider,
//       e.g. <LiveBadge>0:42 / 5:00</LiveBadge>. size: sm (list rows, 18px) | md (22px, default) | lg (28px, headers)
//   <QueuedBadge size? label? title? className? />   the queued state: dashed outline chip with the dashed ring
// Running rows and headers use LiveBadge; failed / cancelled stay ink (<JobState>).
import type { ReactNode } from "react";
import { VerdictGlyph } from "./Glyphs";
import { cx } from "./cx";

type BadgeSize = "sm" | "md" | "lg";

export function LiveBadge({
  size = "md",
  label = "Live",
  ping = true,
  title,
  className,
  children,
}: {
  size?: BadgeSize;
  label?: string;
  ping?: boolean;
  title?: string;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <span className={cx("live-badge", size !== "md" && `live-badge--${size}`, className)} title={title}>
      {ping && <span className="ping" aria-hidden="true" />}
      {label}
      {children !== undefined && children !== null && children !== false && <span className="lb-x">{children}</span>}
    </span>
  );
}

export function QueuedBadge({ size = "md", label = "Queued", title, className }: { size?: BadgeSize; label?: string; title?: string; className?: string }) {
  return (
    <span className={cx("queued-badge", size !== "md" && `queued-badge--${size}`, className)} title={title}>
      <VerdictGlyph v="pending" />
      {label}
    </span>
  );
}
